<div class="container">
  <pdq-heading element="h6">General</pdq-heading>
  <div class="general">
    <div class="settings-row">
      <pdq-input label="API Key" [(ngModel)]="apiKey" [value]="apiKey"></pdq-input>
      <pdq-button label="Save" variant="primary" (onClick)="save()"></pdq-button>
    </div>

    <div class="settings-row">
      <pdq-input
        label="Bearer Token for Richpanel"
        [(ngModel)]="bearerToken"
        [value]="bearerToken"
        disabled="true"
        clipboard="true"
        style="width: 30%"></pdq-input>
    </div>
  </div>
</div>
